import axios from 'axios'
import {
  responseErrorInterceptor,
  responseSuccessInterceptor
} from './interceptors'

const _axios = axios.create()
_axios.defaults.baseURL = process.env.REACT_APP_API_URL
_axios.defaults.withCredentials = true
_axios.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
)

const apiService = {
  async request({ method, uri, data, axiosConfig = {} }) {
    const requestConfig = {
      uri,
      method,
      data: data,
      axiosConfig
    }

    return await _axios.request(this._prepareRequestConfig(requestConfig))
  },

  get: async function get(uri, config) {
    return await this.request({
      method: 'get',
      uri,
      data: undefined,
      axiosConfig: config ?? {}
    })
  },

  async patch(uri, data, axiosConfig = {}) {
    return await this.request({
      method: 'patch',
      uri,
      data,
      axiosConfig
    })
  },

  async delete(uri, data, axiosConfig = {}) {
    return await this.request({
      method: 'delete',
      uri,
      data,
      axiosConfig
    })
  },

  async post(uri, data, axiosConfig = {}) {
    return await this.request({
      method: 'post',
      uri,
      data,
      axiosConfig
    })
  },

  async put(uri, data, config) {
    return await this.request({
      method: 'put',
      uri,
      data,
      axiosConfig: config ?? {}
    })
  },

  _getErrorMessage(error) {
    let message = 'Unknown error'

    if (error.response !== undefined) {
      message = error.response.data.message
    } else {
      message = error.message
    }

    return message
  },

  _prepareRequestConfig({ uri, axiosConfig, data, method }) {
    const body = this._prepareBody(data)
    const headers = this._prepareHeaders(data)
    const requestConfig = {
      ...axiosConfig,
      url: uri,
      headers,
      method
    }

    if (method !== 'get' && data !== undefined) {
      requestConfig.data = body
    }

    return requestConfig
  },

  _isFormData(data) {
    return data instanceof FormData
  },

  _prepareHeaders(data) {
    const headers = {}

    if (data !== undefined) {
      if (!this._isFormData(data)) {
        headers['Content-Type'] = 'application/json'
      } else {
        headers['Content-Type'] = 'multipart/form-data'
      }
    }

    return headers
  },

  _prepareBody(data) {
    return this._isFormData(data) ? data : JSON.stringify(data)
  }
}

export default apiService
